import {createAction, props} from '@ngrx/store';
import {ListOfValue} from 'shared/models/ListOfValue';

export const addLOVs = createAction(
  '[LOV] Add LOVs',
  props<{ newLOVs: ListOfValue[] }>(),
);
